"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("../styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var UploadImg = function UploadImg(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor,
    _ref$animation = _ref.animation,
    animation = _ref$animation === void 0 ? '' : _ref$animation;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_react["default"].createElement(_styles.Svg, {
    className: "".concat(className, " ").concat(animation),
    width: size,
    height: size,
    viewBox: "0 0 81 80",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M59.5 10v20.5m10.25-10.25h-20.5M42.5 14H17a6 6 0 0 0-6 6v33.5M66.5 37v5M11 53.5V64a6 6 0 0 0 6 6h33M11 53.5c4.628-.392 11.854-.127 19 1.847M50 70h10.5a6 6 0 0 0 6-6V42M50 70c-4.023-8.047-11.961-12.432-20-14.653M66.5 42C53.5 41 38 44 30 55.347"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: 27.5,
    cy: 31,
    r: 5.5,
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }));
};
var _default = exports["default"] = UploadImg;